// Cómo se mete cada cara de mentor en su disco.
//
// VIVE AQUÍ Y NO EN `RetratoDeMentor.jsx` DESDE EL 3 DE NOVIEMBRE DE 2026 porque lo pintan dos
// sitios: la plataforma y el vídeo de la portada (`scripts/manifiesto/plantilla.html`), que no
// corre React. El vídeo las ponía sin ajustar y Gabri lo vio: *«los mentores no aparecen centrados
// en los círculos»*. Una tabla, un sitio.

// CADA CARA OCUPA UNA PARTE DISTINTA DE SU LIENZO: Sócrates deja aire y a Ariadna la melena se le
// sale por abajo. Esto iguala las seis en una fila de discos. Se mide con `check_retratos.py`:
// el dibujo no puede quedar pequeño ni apretado contra el cristal.
//
// Ariadna va a 1 a propósito: su melena acaba en un corte recto, y al encogerla para meterla
// entera se ve ese corte. Mejor que la recorte el disco, que es lo que le pasa a un pelo en un
// retrato; la cara, que es lo que se mira, queda entera.
export const ENCAJE = {
  socratico: 1.06, filosofia: 1.06, literatura: 1.04,
  psicologia: 1, "cultura-clasica": 1.08, musica: 1.14,
};
// Lo que hay que mover cada dibujo para que quede en el centro, en fracción de su lienzo: cuatro de
// los seis no están centrados en su imagen.
//
// LO QUE SE CENTRA ES LA CARA, NO EL DIBUJO. Medido por los extremos, a Ulises le contaba el nudo
// de la cinta, que le sale por un lado, y su cara se quedaba a la izquierda (Gabri, 3 de noviembre
// de 2026: *«no está centrado como los demás»*). Se mide el eje de simetría de la cara.
export const CENTRA_X = {
  socratico: -0.006, filosofia: 0.053, literatura: 0,
  psicologia: 0.006, "cultura-clasica": 0.044, musica: 0.039,
};
export const CENTRA_Y = {
  socratico: 0.046, filosofia: 0.004, literatura: 0.006,
  psicologia: 0.003, "cultura-clasica": 0, musica: 0.018,
};

/** El `transform` de la imagen dentro del disco. Sin encaje, la cara tal cual. */
export const encajeDeLaCara = (character) => {
  const escala = ENCAJE[character] || 1;
  const x = (CENTRA_X[character] || 0) * 100;
  const y = (CENTRA_Y[character] || 0) * 100;
  return `scale(${escala}) translate(${x}%, ${y}%)`;
};
